var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashCanWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.01 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1{isolation:isolate;}\r\n      .cls-2{fill:#FDFDFD;fill-rule:evenodd;}\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard_2",
    "data-name": "Artboard 2",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uppdrag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_538",
    "data-name": "Shape 538"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.88,10.65,31.36,8.4A1.83,1.83,0,0,0,30,7.68H26.48V4.63a2.38,2.38,0,0,0-.61-1.47L23.29.61A2.42,2.42,0,0,0,21.81,0H11.15A2.42,2.42,0,0,0,9.67.61L7.28,3a2.38,2.38,0,0,0-.61,1.47V7.68H3a1.83,1.83,0,0,0-1.35.71L.13,10.63c-.27.39-.09.71.38.71H3.06v27.8a.87.87,0,0,0,.87.86H29.26a.87.87,0,0,0,.87-.86V11.36H32.5C33,11.36,33.15,11,32.88,10.65ZM10.28,5.93a2.38,2.38,0,0,1,.61-1.47l.28-.27a2.42,2.42,0,0,1,1.48-.61h7.67a2.42,2.42,0,0,1,1.48.61l.46.46a2.38,2.38,0,0,1,.61,1.47V7.5a.85.85,0,0,1,0,.19H10.3a.85.85,0,0,1,0-.19ZM26.52,35.56a.87.87,0,0,1-.87.86H7.53a.87.87,0,0,1-.87-.86V12.21a.87.87,0,0,1,.87-.86H25.72a.86.86,0,0,1,.8.85ZM11,13.77H10a.87.87,0,0,0-.87.86V33.21a.87.87,0,0,0,.87.86h1a.87.87,0,0,0,.87-.86V14.63A.87.87,0,0,0,11,13.77Zm6,0H16a.87.87,0,0,0-.87.86V33.21a.87.87,0,0,0,.87.86h1a.87.87,0,0,0,.87-.86V14.63A.87.87,0,0,0,17.06,13.77Zm6,0H22a.87.87,0,0,0-.87.86V33.21a.87.87,0,0,0,.87.86h1a.86.86,0,0,0,.87-.86V14.63A.87.87,0,0,0,23.07,13.77Z"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanWhite);
export default __webpack_public_path__ + "static/media/TrashCanWhite.a64bb28ac08777f9956f69abd916496f.svg";
export { ForwardRef as ReactComponent };